module.exports = __webpack_public_path__ + "static/media/paiement-cb.4f468576.png";